import React from 'react';

export default class  Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt=""
                                                 src={require('@images/How to motivate others.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title">
                                            <span className="heading">
                                            <img className="heading_image"
                                                 src={require('@images/browndot.jpg')}/>
                                            </span>
                                                <span className="heading">isn't it interesting?</span>
                                            </div>
                                            <p>Love ’em or hate ’em, rats are smart, and they’ve been explaining a
                                                thing or two to us. They’ve been at the leading edge of
                                                psychological research into what motivates us and how, which is
                                                helpful. Thanks, mates.</p>
                                            <div className="border_subtitle">How do we motivate others?</div>
                                            <p>People are motivated by all kinds of things. At the most basic level,
                                                we’re driven by simple needs, as we illustrate below. Once these
                                                needs are satisfied, what motivates or gives us purpose, varies with
                                                each of us.</p>
                                            <div className="lightgreencontentbg keyquestionpad ">
                                                <div className="border_subtitle">Trick or treat</div>
                                                <p>In a series of revealing and insightful studies into motivation
                                                    and survival back in the 1970s,
                                                    researchers managed to ‘teach’ rats to ring bells, pull levers
                                                    and escape from a complex
                                                    maze.<a className="superscripttext"
                                                            href="further_info.php?course=300"><sup>1</sup></a> How?
                                                    By tapping into the most basic of animal and human needs,
                                                    providing food as
                                                    an immediate and positive reward for action.</p>
                                                <p>Rats were put in boxes with a simple lever and a food chute. Each
                                                    rat would typically run
                                                    around the box, scratching, climbing and exploring until
                                                    eventually it accidentally pulled on
                                                    the lever. This caused a pellet of food to be released down the
                                                    chute. Initially, the rats made
                                                    no association between lever and food, but after a few
                                                    consecutive taps of the lever, they
                                                    recognised the connection, pressing the lever more frequently
                                                    for food pellets. The
                                                    researchers then alternated the delivery of the food, sometimes
                                                    delaying its timing or
                                                    changing the effort required to get it – in much the same way
                                                    that work and targets can
                                                    be adapted!</p>
                                                <div className="uiheading"><p>These experiments are now recognised
                                                    as critical to our understanding of learning and
                                                    motivation. They provided new insights into the most basic way
                                                    our actions can be (and
                                                    often are) reinforced by positive rewards. Of course, we’re not
                                                    rats, but we share the same
                                                    basic needs.</p></div>
                                            </div>

                                            <div className="right-btn">
                                                <div className="button-next-previous-done" onClick={this.props.handleChangePage('Page2')}>Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}